export const GET_INSTRUCTOR_SCHEDULES = "GET_INSTRUCTOR_SCHEDULES";
